import styled from "styled-components";

export const StyledWrapperInput = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
